import { render, staticRenderFns } from "./cope-with-submission-details.vue?vue&type=template&id=3c28cc93&"
import script from "./cope-with-submission-details.vue?vue&type=script&lang=js&"
export * from "./cope-with-submission-details.vue?vue&type=script&lang=js&"
import style0 from "./cope-with-submission-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports